/**
 * Petites règles d'accord du français.
 *
 * Un rapport qui annonce « 1 doublons » donne l'impression d'un outil bâclé ;
 * l'accord se fait donc à l'affichage, pas à la main dans chaque phrase.
 */

/** « 3 lignes », « 1 ligne » — le pluriel par défaut est le singulier + « s ». */
export function accorde(nombre: number, singulier: string, pluriel?: string): string {
  return nombre > 1 ? (pluriel ?? `${singulier}s`) : singulier;
}
